import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.4.0@rc-rate/es/index.js
// module id = 772
// module chunks = 1